import { environment } from '../../environments/environment';

export const dataMartApiConfig = environment.dataMartApi;
